import React from 'react';
import { Box, styled, Typography } from '@mui/material';

import CommentSelect from './CommentSelect';
import TicketSearch from './TicketSearch';
import VariableList from './VariableList';

const _Inputs = styled(Box)`
    display: flex;
    margin-bottom: ${({ theme }) => theme.spacing(2)};
`;

export const VariablesSidebarContent = () => (
    <>
        <Typography variant="h5" sx={{ mt: 2 }}>
            Variables
        </Typography>
        <_Inputs>
            <TicketSearch />
            <CommentSelect />
        </_Inputs>
        <VariableList />
    </>
);
